<template>
	<div>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="deleteData"
			:active.sync="isSidebarActiveLocal" color="danger" @cancel="clearFields" @close="clearFields">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t('DeleteWarning') }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
	</div>
</template>
<script>
export default {
	props: {
		isPromptActive: {
			type: Boolean,
			required: true
		},
		data: {
			default: () => { }
		}
	},

	computed: { 
		isSidebarActiveLocal: {
			get() {
				return this.isPromptActive
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
	},
	
	methods: {
		deleteData() { this.$root.$emit("deleteSubmit", this.data); },
		clearFields() {
			this.isSidebarActiveLocal = false
			this.$root.$emit("closeDeleteWarning");

		},
	},
	
}

</script>